import {withFormik} from "formik";
import * as yup from "yup"
import {englishCharRegExp} from "../../../services/regex"
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {fileForCategoriesInVideoProductApi} from "../../../constans/apiUrls";
import {IFileForCategoryInVideoProductItemData} from "../../../contracts/data/file_category";
import {FileType, VideoLinkType} from "../../../constans/enumTypes";
import InnerFileForCategoryInVideoProductForm
    from "../../../components/FormTemplates/video_product/InnerFileForCategoryInVideoProductForm";


const fileForCategoryInVideoProductFormValidationSchema = yup.object().shape({
    category: yup.array().min(1, 'انتخاب حداقل یک دسته بندی الزامی میباشد').required('انتخاب دسته بندی ها الزامی میباشد'),
    title: yup.string().required("عنوان الزامی میباشد"),
    slug: yup.string().required("نامک الزامی میباشد").matches(englishCharRegExp, "حروف نامک باید انگلیسی باشد"),
    link: yup.string().required("لینک فایل الزامی میباشد"),
    time: yup.string().required("زمان فایل الزامی میباشد"),
    size: yup.string().required("سایز فایل الزامی میباشد"),
    release_date_jalali: yup.string().required("تاریخ انتشار الزامی میباشد"),
})

interface IFileForCategoryInVideoProductFormProps {
    formType?: string,
}

const FileForCategoryInVideoProductForm = withFormik<IFileForCategoryInVideoProductFormProps, IFileForCategoryInVideoProductItemData>({
    mapPropsToValues: props => ({
        id: 0,
        category: [],
        title: '',
        slug: '',
        link_type: VideoLinkType.KAVIMO,
        type: FileType.VIDEO,
        link: '',
        attachment: '',
        attachment_url: '',
        time: '',
        content: '',
        size: '',
        release_date: '',
        release_date_jalali: '',
        is_free: false,
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: fileForCategoryInVideoProductFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.attachment && isNotEmpty(values.attachment) && typeof values.attachment === 'object') {
            formData.append('attachment', values.attachment)
        }
        values.slug = values.slug.replaceAll(" ", "_")
        formData.append('data', JSON.stringify(values));
        if (formikBag.props.formType === 'create') {
            await httpClient().post(fileForCategoriesInVideoProductApi.create, formData)
                .then(response => {
                    if(response.status === 201 || response.status === 200 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            values.slug = values.slug.replaceAll(" ", "_")
            await httpClient().put(`${fileForCategoriesInVideoProductApi.update}/${values.id}`, formData)
                .then(response => {
                    if(response.status === 200){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        }
    },
    displayName: 'FileForCategoryInVideoProductForm'
})(InnerFileForCategoryInVideoProductForm)

export default FileForCategoryInVideoProductForm